import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit, ViewChild} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {catchError, concat, map, Observable, ObservableInput, of, startWith} from 'rxjs';
import {ErrorCodes} from '../../constants/ErrorCodes';
import {RemitoTypeMapping, RemitoTypes} from '../../constants/RemitoTypes';
import {UserFunctionCode} from '../../constants/UserFunctionCode';
import {PtoEmision} from '../../models/PtoEmision';
import {Details, Observacion, Prorrogas, Remito} from '../../models/Remito';
import {Clase, IdDescModel, RemitoCreationDetails, Solicitante} from '../../models/RemitoCreationDetails';
import {NotificationService} from '../../services/notification.service';
import {PtoEmisionService} from '../../services/ptoEmision.service';
import {RemitoService} from '../../services/remito.service';
import {SecurityService} from '../../services/security.service';

import {
  GenerateRemitosNumberComponent
} from '../../shared-components/generate-remitos-number/generate-remitos-number.component';


@Component({
  selector: 'app-create-remito',
  templateUrl: './create-remito.component.html',
  styleUrls: ['./create-remito.component.scss']
})
export class CreateRemitoComponent implements OnInit {
  @ViewChild('formDirective') private formDirective: FormGroupDirective;

  title = 'Create New Tactic';
  isLoading = false;
  isSaving = false;
  user: string;
  dataSource: MatTableDataSource<RemitoCreationDetails> = new MatTableDataSource<RemitoCreationDetails>();
  createDetailsData: RemitoCreationDetails[] = [];
  saveDisabled = false;
  hideDetails = false;
  hideObservacion = false;
  hideRetorno = false;
  isView = false;
  canView: boolean = false;
  hideProrrogas = false;
  errors: HttpErrorResponse[] = [];
  previousRemito = false;

  mgoInvalidDestinatario = false;
  mgoInvalidTransporte = false;

  clase: Clase[] = [
    {id: 'N', viewValue: 'No Commercial'},
    {id: 'O', viewValue: 'Commercial'},
  ];
  public claseSelected = 'N';
  solicitante: Solicitante[] = [];
  transporte: IdDescModel[] = [];
  motivo: IdDescModel[] = [];
  destinatario: IdDescModel[] = [];
  today: Date = new Date();
  tomorrow: Date = new Date(this.today);

  todayDate = new FormControl(new Date());
  ptoEmisionControl = new FormControl('', Validators.required);
  nroRemitoControl = new FormControl<string | null>({value: null, disabled: true});
  nroTicketControl = new FormControl('');
  fecGenControl = new FormControl(new Date());
  fecSalidaControl = new FormControl(new Date());
  fecARetornarControl = new FormControl<Date | null>(null);
  nroShipperControl = new FormControl<string | null>({value: null, disabled: true});
  dunsDockControl = new FormControl<string | null>({value: null, disabled: true});
  solicitanteInputControl = new FormControl([''], Validators.required);
  solicitanteControl = new FormControl<string | Solicitante>('');
  almacenControl = new FormControl<string>('');
  dockControl = new FormControl<string>('');
  transporteControl = new FormControl<string | IdDescModel>('', Validators.required);
  patenteControl = new FormControl('', Validators.required);
  motivoControl = new FormControl<string | IdDescModel>('');
  destinatarioControl = new FormControl<string | IdDescModel>('', Validators.required);
  pNetoControl = new FormControl<number | null>(null);
  taraControl = new FormControl<number | null>(null);
  pBrutoControl = new FormControl<number | null>(null);
  cantContControl = new FormControl('');
  observacionControl1 = new FormControl('');
  observacionControl2 = new FormControl('');
  observacionControl3 = new FormControl('');
  // fechaProrrogasControl = new FormControl<Date | null>(null);
  // docProrrogasControl = new FormControl('');
  fechaRetornoControl = new FormControl<Date | null>(null, {updateOn: "change"});
  docRetornoControl = new FormControl('', {updateOn: "change"});

  createRemitoForm: FormGroup = new FormGroup({
    ptoEmision: this.ptoEmisionControl,
    nroRemito: this.nroRemitoControl,
    nroTicket: this.nroTicketControl,
    fecGen: this.fecGenControl,
    fecSalida: this.fecSalidaControl,
    fecRectornar: this.fecARetornarControl,
    nroShipper: this.nroShipperControl,
    dunsDock: this.dunsDockControl,
    solicitante: this.solicitanteControl,
    almacen: this.almacenControl,
    dock: this.dockControl,
    transporte: this.transporteControl,
    patente: this.patenteControl,
    pNeto: this.pNetoControl,
    tara: this.taraControl,
    pBruto: this.pBrutoControl,
    cantCont: this.cantContControl,
    observacion1: this.observacionControl1,
    observacion2: this.observacionControl2,
    observacion3: this.observacionControl3,
    // fecProrrogas: this.fechaProrrogasControl,
    // observacion: this.docProrrogasControl,
    fechaRetorno: this.fechaRetornoControl,
    docRetorno: this.docRetornoControl,
    destinatario: this.destinatarioControl,
    motivo: this.motivoControl,

  });


  filteredSolicitante: Observable<Solicitante[]> | undefined;
  filteredTransporte: Observable<IdDescModel[]> | undefined;
  filteredDestinatario: Observable<IdDescModel[]> | undefined;
  filteredMotivo: Observable<IdDescModel[]> | undefined;

  validSolicitante: string[] = [];
  validTransporte: string[] = [];
  validDestinatario: string[] = [];
  validMotivo: string[] = [];

  selectedTransporte: string;
  rmtNum: number | null;
  remitoNumFromRoute: number;
  ptoEmisionFromRoute: string;
  remitos: Remito;
  remitoType: RemitoTypes | undefined = RemitoTypes.FREE;
  origen: string = "FRE";
  observation = [];
  allPtoEmision: PtoEmision[] = [];
  selectedOption: string | null = '0015';
  disablePtoEmision: boolean;
  remitoStatus: string | null;
  //Detaille Section
  form = this.fb.group({
    detalle: this.fb.array([]),
    detallePayload: this.fb.array([]),
    prorrogas: this.fb.array([])
  });

  constructor(private fb: FormBuilder,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private remitoService: RemitoService,
              private securityService: SecurityService,
              private notificationService: NotificationService,
              private ptoEmisionService: PtoEmisionService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.almacenControl.disable();
    this.fecGenControl.disable();
    this.dockControl.disable({emitEvent: true});
    this.user = this.securityService.LOGGED_USER.gmin;
    this.canView = !this.securityService.can(UserFunctionCode.CREATE_REMITO);
    this.tomorrow.setDate(this.tomorrow.getDate() + 1)

    const routeParams = this.route.snapshot.paramMap;
    this.remitoNumFromRoute = Number(routeParams.get('remitoNum'));
    this.ptoEmisionFromRoute = String(routeParams.get('ptoEmision'));
    if (this.remitoNumFromRoute && this.ptoEmisionFromRoute) {
      this.isView = true;
    } else {
      this.getPtoEmision();
      this.addDetalle(0);
    }

    this.isLoading = true;
    this.fetchData();

  }

  fetchData() {
    let obs: ObservableInput<any>[] = [];
    let hasError = false;
    obs.push(this.remitoService.getDetails().pipe(map((response) => {
          if (response) {
            // @ts-ignore
            this.createDetailsData = response;
            this.dataSource = new MatTableDataSource<RemitoCreationDetails>(this.createDetailsData);
            // this.ptoEmisionControl.setValue("0015");
            for (let i = 0; i < response.solicitante.length; i++) {
              this.solicitante.push(response.solicitante[i]);
              this.validSolicitante.push(response.solicitante[i].id + ' - ' + response.solicitante[i].name);
            }
            this.validSolicitante.push('');
            this.populateSolicitante();
            for (let i = 0; i < response.transporte.length; i++) {
              this.transporte.push(response.transporte[i]);
              this.validTransporte.push(response.transporte[i].id + ' - ' + response.transporte[i].desc);
            }
            this.validTransporte.push('');
            this.populateTransporte();
            for (let i = 0; i < response.motivo.length; i++) {
              this.motivo.push(response.motivo[i]);
              this.validMotivo.push(response.motivo[i].id + ' - ' + response.motivo[i].desc);
            }
            this.validMotivo.push('');
            this.populateMotivo();
            for (let i = 0; i < response.destinatario.length; i++) {
              this.destinatario.push(response.destinatario[i]);
              this.validDestinatario.push(response.destinatario[i].id + ' - ' + response.destinatario[i].desc+ ' - ' + response.destinatario[i].city);
            }
            this.validDestinatario.push('');
            this.populateDestinatario();
            //this.addValidators()
          }
        }),
        catchError(() => {
          hasError = true;
          return of(null);
        })
      ),
    );

    if (this.isView) {
      obs.push(this.remitoService.getRemitoById(this.remitoNumFromRoute, this.ptoEmisionFromRoute).pipe(map((response) => {
          this.remitos = response;
          this.changeRemitoType(RemitoTypeMapping.MAPPING.get(response.origen) ?? RemitoTypes.FREE);
          this.origen = response.origen;
          this.ptoEmisionControl.setValue(response.ptoEmision);
          this.nroRemitoControl.setValue(String(response.nroRemito).padStart(8, '0'));
          this.nroTicketControl.setValue(response.nroTicket);
          this.claseSelected = response.clase ?? '';
          this.fecGenControl.setValue(response.fecGen);
          this.fecSalidaControl.setValue(response.fecSalida);
          this.fecARetornarControl.setValue(response.fecARetornar);
          this.nroShipperControl.setValue(String(response.nroShipper));
          this.dunsDockControl.setValue(String(response.dunsDock));
          this.patenteControl.setValue(response.patenteTransp);

          if (response.nameSolicitante != null) {
            this.solicitanteControl.setValue(response.idSolicitante + ' - ' + response.nameSolicitante);
          } else {
            this.solicitanteControl.setValue(response.idSolicitante ?? '');
            //this.solicitanteControl.setErrors({'in-valid-list': true});
            //this.solicitanteControl.markAllAsTouched();
          }

          if (response.descAlmacen != null) {
            this.almacenControl.setValue(response.codAlmacen + ' - ' + response.descAlmacen);
          } else {
            this.almacenControl.setValue(response.codAlmacen);
          }

          if (response.dockDesc != null) {
            this.dockControl.setValue(response.shipFrom + ' - ' + response.dockDesc);
          } else {
            this.dockControl.setValue(response.shipFrom);
          }

          if (response.nombreTransp != null) {
            this.transporteControl.setValue(response.codTransp + ' - ' + response.nombreTransp);
          } else {
            this.transporteControl.setValue(response.codTransp ?? '');
            //this.transporteControl.setErrors({'in-valid-list': true});
            //this.transporteControl.markAllAsTouched();
          }

          if (response.descMotivo != null) {
            this.motivoControl.setValue(response.codMotivo + ' - ' + response.descMotivo);
          } else {
            this.motivoControl.setValue(response.codMotivo ?? '');
            //this.motivoControl.setErrors({'in-valid-list': true});
            //this.motivoControl.markAllAsTouched();
          }

          if (response.nombreDealer != null) {
            this.destinatarioControl.setValue(response.codDealer + ' - ' + response.nombreDealer + ' - ' +response.dlCiudad );
          } else {
            this.destinatarioControl.setValue(response.codDealer ?? '');
            //this.destinatarioControl.setErrors({'in-valid-list': true});
            //this.destinatarioControl.markAllAsTouched();
          }

          this.pNetoControl.setValue(response.pesoNetoCont);
          this.taraControl.setValue(response.taraCont);
          this.pBrutoControl.setValue(response.pesoBrutoCont);
          this.cantContControl.setValue(response.totalCont);
          this.selectedOption = response.ptoEmision;
          this.getPtoEmision();
          this.remitoStatus = response.estadoRemito;
          if (this.remitoStatus !== 'Aprobado' || this.remitoType == 'MGO') {
            this.ptoEmisionControl.disable();
          }
          this.previousRemito = true;
          this.disabledPrinted();
          this.disablePtoEmision = true;
          if (response.details) {
            for (let i = 0; i < response.details.length; i++) {
              this.addDetalle(i);
            }
            this.detalle.patchValue(response.details);
            this.detallePayload.patchValue(response.details);
          }
          if (response.prorrogases) {
            for (let i = 0; i < response.prorrogases.length; i++) {
              this.addProrrogas(true);
            }
            this.prorrogas.patchValue(response.prorrogases);
            if (!response.fecRetorno) {
              this.addProrrogas(false);
            }
          }
          if (response.observacions) {
            // Avoid out-of-bounds issues
            if (response.observacions.length > 0) {
              this.observacionControl1.setValue(response.observacions[0].observacion);
            }
            if (response.observacions.length > 1) {
              this.observacionControl2.setValue(response.observacions[1].observacion);
            }
            if (response.observacions.length > 2) {
              this.observacionControl3.setValue(response.observacions[2].observacion);
            }
          }

          // Only show if printed and has fecARetornar date
          if (response.estadoRemito === "Impreso" && response.fecARetornar) {
            this.fechaRetornoControl.setValue(response.fecRetorno);
            this.docRetornoControl.setValue(response.docRetorno);
            this.saveDisabled = false;
            // if data already exists, lock save button and disable fields
            if (response.fecRetorno) {
              this.saveDisabled = true;
              this.fechaRetornoControl.disable();
              this.docRetornoControl.disable();
            } else {
              // if fields are editable, set conditional validation
              this.conditionalRequiredValidation(this.fechaRetornoControl, this.docRetornoControl);
              this.conditionalRequiredValidation(this.docRetornoControl, this.fechaRetornoControl);
            }
          }
          this.hideSection(response.details, response.observacions);
        }),
        catchError(() => {
          hasError = true;
          return of(null);
        })
      ));
    }

    concat(...obs).subscribe({
      next: undefined,
      error: undefined,
      complete: () => {
        this.addValidators()
        if (this.isView) {
          this.createRemitoForm.markAllAsTouched();
        }
        this.isLoading = false;
        if (hasError) {
          this.notificationService.open(ErrorCodes.UNKNOWN_ERROR, 'error');
          this.saveDisabled = true;
        }
      }
    });

  }

  addValidators() {
    if (this.remitoType == RemitoTypes.MGO) {
      this.validateMgo();
    } else {
      this.solicitanteControl.addValidators([Validators.required, CreateRemitoComponent.checkInValidList(this.validSolicitante)]);
      this.solicitanteControl.updateValueAndValidity();
      this.transporteControl.addValidators(CreateRemitoComponent.checkInValidList(this.validTransporte));
      this.transporteControl.updateValueAndValidity();
      this.motivoControl.addValidators([Validators.required, CreateRemitoComponent.checkInValidList(this.validMotivo)]);
      this.motivoControl.updateValueAndValidity();
      this.destinatarioControl.addValidators(CreateRemitoComponent.checkInValidList(this.validDestinatario));
      this.destinatarioControl.updateValueAndValidity();
    }
  }

  validateMgo() {
    if (this.remitos.nombreTransp == null || this.remitos.codTransp == null) {
      this.mgoInvalidTransporte = true;
      this.transporteControl.enable();
      this.transporteControl.setErrors({'in-valid-list': true});
    }
    if (this.remitos.nombreDealer == null || this.remitos.codDealer == null) {
      this.mgoInvalidDestinatario = true;
      this.destinatarioControl.enable();
      this.destinatarioControl.setErrors({'in-valid-list': true});
    }
  }

  getPtoEmision() {
    this.ptoEmisionService.getPartsPtoEmision().subscribe((response) => {
      this.allPtoEmision = response;

      for (let i = 0; i < this.allPtoEmision.length; i++) {
        {
          if (this.allPtoEmision[i].code === this.selectedOption) {
            this.ptoEmisionControl.setValue(this.allPtoEmision[i].code)
          }
        }
      }
    });
  }

  populateSolicitante() {
    this.filteredSolicitante = this.solicitanteControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const solicitanteValue = typeof value === 'string' ? value : value?.id;
        return solicitanteValue ? this.solicitanteFiltering(solicitanteValue as string) : this.solicitante.slice();
      }),
    );
  }

  populateTransporte() {
    this.filteredTransporte = this.transporteControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const transporteValue = typeof value === 'string' ? value : value?.desc;
        return transporteValue ? this.transporteFiltering(transporteValue as string) : this.transporte.slice();
      }),
    );
  }

  populateMotivo() {
    this.filteredMotivo = this.motivoControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const motivoValue = typeof value === 'string' ? value : value?.desc;
        return motivoValue ? this.motivoFiltering(motivoValue as string) : this.motivo.slice();
      }),
    );
  }

  populateDestinatario() {
    this.filteredDestinatario = this.destinatarioControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const destinatarioValue = typeof value === 'string' ? value : value?.desc;
        return destinatarioValue ? this.destinatarioFiltering(destinatarioValue as string) : this.destinatario.slice();
      }),
    );
  }

  private solicitanteFiltering(input: string): Solicitante[] {
    const filterValue = input.toLowerCase();
    return this.solicitante.filter(option => option.name.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private transporteFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.transporte.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private motivoFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.motivo.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  private destinatarioFiltering(name: string): IdDescModel[] {
    const filterValue = name.toLowerCase();
    return this.destinatario.filter(option => option.desc.toLowerCase().includes(filterValue) || option.id.toLowerCase().includes(filterValue));
  }

  solicitanteSelection(inputId: string) {
    const solicitante = this.solicitante.find(o => o.id === inputId) ?? new Solicitante();
    let resultAlmacen: IdDescModel = solicitante.almacen;
    let resultDock: IdDescModel = solicitante.dock;

    this.almacenControl.setValue(resultAlmacen.id + ' - ' + resultAlmacen.desc);
    this.dockControl.setValue(resultDock.id + ' - ' + resultDock.desc);

    if (!resultAlmacen.estado) {
      this.solicitanteControl.setErrors({'almacen-blocked': true});
    } else if (!resultDock.estado) {
      this.solicitanteControl.setErrors({'dock-inactive': true});
      this.notificationService.open(ErrorCodes.INACTIVE_DOCK, 'error');
    }

  }

  //Detalle Section we show on the UI that does not include the deleted row
  get detalle() {
    return this.form.controls['detalle'] as FormArray;
  }

  //Detalle payload we send to backend that does include the deleted rows
  get detallePayload() {
    return this.form.controls['detallePayload'] as FormArray;
  }

  addDetalle(i: number) {
    let detalleForm = this.fb.group({
      id: [''],
      nroItemDet: i + 1,
      nroParte: [''],
      descParte: [''],
      cantidad: [''],
      unidadMedida: [''],
      pesoNeto: [''],
      deleted: false
    });
    detalleForm.controls.nroItemDet.disable();
    this.detalle.push(detalleForm);
    this.detallePayload.push(detalleForm);

    if (this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView || this.remitoType === 'MGO') {
      detalleForm.controls.nroItemDet.disable();
      detalleForm.controls.nroParte.disable();
      detalleForm.controls.descParte.disable();
      detalleForm.controls.cantidad.disable();
      detalleForm.controls.unidadMedida.disable();
      detalleForm.controls.pesoNeto.disable();
    }
  }

  deleteLesson(detalleIndex: number) {
    //Deleting the row from the array that displays on UI
    this.detalle.removeAt(detalleIndex);
    //Setting the delete value to true so backend can delete from DB
    // @ts-ignore
    this.detallePayload.controls[detalleIndex].get("deleted").setValue(true);
    this.detallePayload.controls[detalleIndex].markAsDirty();
  }

  //Prorrogas Section
  get prorrogas() {
    return this.form.controls['prorrogas'] as FormArray;
  }

  addProrrogas(disable: boolean) {
    let prorrogasForm = this.fb.group({
      id: [''],
      nroItemObs: [''],
      fecProrrogas: [''],
      observacion: ['']
    });

    if (disable || this.canView) {
      prorrogasForm.controls.fecProrrogas.disable();
      prorrogasForm.controls.observacion.disable();
    } else {
      // if fields are editable, set conditional validation
      this.conditionalRequiredValidation(prorrogasForm.controls.fecProrrogas, prorrogasForm.controls.observacion);
      this.conditionalRequiredValidation(prorrogasForm.controls.observacion, prorrogasForm.controls.fecProrrogas);
    }
    this.prorrogas.push(prorrogasForm);

  }

  deleteProrrogas(prorrogasIndex: number) {
    this.prorrogas.removeAt(prorrogasIndex);
  }

  /**
   * When a value is present for a FormControl, set another FormControl as required; If the value is
   * removed, the required validator will also be removed. The `updateValueAndValidity()` method ensures that the field
   * is immediately updated, and the `markAsTouched()` method ensures that the visual error cues are
   * immediately displayed.
   * @param {FormControl} controlDeterminingValidation - The field determining if validation should be added
   * @param {FormControl} controlToBeValidated - The field that will be validated
   * @author MZ8VM2 (Kayla Hanks)
   */
  conditionalRequiredValidation(controlDeterminingValidation: FormControl, controlToBeValidated: FormControl) {
    controlDeterminingValidation.valueChanges.subscribe(
      (value: any) => {
        if (value != null && value != "") {
          controlToBeValidated.addValidators(Validators.required);
          controlToBeValidated.updateValueAndValidity({onlySelf: true, emitEvent: false});
          controlToBeValidated.markAsTouched({onlySelf: true});
        } else {
          controlToBeValidated.removeValidators(Validators.required);
          controlToBeValidated.updateValueAndValidity({onlySelf: true, emitEvent: false});
        }
      }
    )
  }

  // Only allows numbers to be inputted no characters
  keyPressNumbers(event: { which: any; keyCode: any; preventDefault: () => void; }) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57) && charCode !== 46) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onChange(ptoEmision: any) {
    this.ptoEmisionControl.setValue(ptoEmision.value);
    this.changeRemitoType(this.getRemitoTypeByPtoEmision(ptoEmision.value));
  }

  save() {
    if ((this.createRemitoForm.valid || this.createRemitoForm.disabled) && this.form.valid) {
      if (this.remitos == null || !this.remitos.printed) {
        this.remitos = new Remito();
      }
      this.saveCabeceraData();
      this.saveDetalleData();
      this.saveObservacion();
      if (this.remitoStatus == "Impreso") {
        this.saveProrrogas();
        this.saveRetorno();
      }
      this.generateRemitosPopup(this.previousRemito);
    } else {
      this.notificationService.open('Crear Remito Inválido. Por favor complete los campos requeridos', 'error')
    }
  }

  saveCabeceraData() {
    this.remitos.origen = this.origen;
    this.remitos.ptoEmision = this.ptoEmisionControl.value;
    this.remitos.clase = this.claseSelected;
    this.remitos.fecGen = this.fecGenControl.value;
    if (this.nroShipperControl.value != null) {
      this.remitos.nroShipper = +this.nroShipperControl.value;
    }
    this.remitos.dunsDock = this.dunsDockControl.value;

    // almacen  -> not saved to header table on Create/Update
    // dock     -> not saved to header table on Create/Update

    if (this.remitoType === 'MGO') {
      this.remitos.dock = this.dockControl.value;
    }

    // solicitante
    // @ts-ignore
    const solicitante = this.solicitanteControl.value.split('-');
    this.remitos.idSolicitante = solicitante[0].trim();

    // motivo
    // @ts-ignore
    const motivo = this.motivoControl.value.toString().split(' - ');
    this.remitos.codMotivo = motivo[0].trim();

    // transporte
    // @ts-ignore
    const transporte = this.transporteControl.value.split('-');
    this.remitos.codTransp = transporte[0].trim();
    this.remitos.patenteTransp = this.patenteControl.value;

    // destinatario
    // @ts-ignore
    const destinatario = this.destinatarioControl.value.split('-');
    this.remitos.codDealer = destinatario[0].trim();
    this.remitos.totalCont = this.cantContControl.value;
    this.remitos.pesoNetoCont = this.pNetoControl.value;
    this.remitos.taraCont = this.taraControl.value;
    this.remitos.pesoBrutoCont = this.pBrutoControl.value;
    // Set initial status for remito/balanza to 'Aprobado'
    if (!this.isView) {
      this.remitos.estadoRemito = 'Aprobado';
      this.previousRemito = false;
      // Add new balanza requires nroRemito value
      if (this.remitoType === RemitoTypes.BALANZA) {
        this.remitos.nroRemito = Number(this.nroRemitoControl.value);
      }
    } else {
      this.remitos.estadoRemito = this.remitoStatus;
      this.remitos.nroRemito = Number(this.nroRemitoControl.value);
    }
    this.remitos.usrCreacion = this.user;
    this.remitos.nroTicket = this.nroTicketControl.value;
    this.remitos.fecSalida = this.fecSalidaControl.value;
    this.remitos.fecARetornar = this.fecARetornarControl.value;
  }

  saveDetalleData() {
    this.remitos.details = [];
    for (let j = 0; j < this.detallePayload.controls.length; j++) {
      if (this.detallePayload.controls[j].dirty) {
        var detail = new Details();
        detail.id = this.detallePayload.controls[j].value.id;
        detail.origen = this.origen;
        detail.ptoEmision = this.ptoEmisionControl.value;
        detail.nroParte = this.detallePayload.controls[j].value.nroParte;
        //detail.nroItemDet = 1;
        detail.descParte = this.detallePayload.controls[j].value.descParte;
        detail.cantidad = this.detallePayload.controls[j].value.cantidad;
        detail.unidadMedida = this.detallePayload.controls[j].value.unidadMedida;
        detail.unidadPeso = this.detallePayload.controls[j].value.unidadPeso;
        detail.pesoNeto = this.detallePayload.controls[j].value.pesoNeto;
        detail.nroParteCdk = this.detallePayload.controls[j].value.nroParteCdk;
        detail.fecCreacion = new Date();
        detail.usrCreacion = this.user;
        detail.fecModif = new Date();
        detail.usrModif = this.user;
        detail.deleted = this.detallePayload.controls[j].value.deleted;
        this.remitos.details.push(detail);
      }
    }
    return;
  }


  saveObservacion() {
    this.remitos.observacions = [];
    let obsSize = 0; // tracks needed length of array
    if (this.observacionControl1.value || this.observacionControl1.dirty) {
      // @ts-ignore
      this.observation.push(this.observacionControl1.value);
      obsSize = 1;
    } else {
      // @ts-ignore
      this.observation.push('');
    }
    if (this.observacionControl2.value || this.observacionControl2.dirty) {
      // @ts-ignore
      this.observation.push(this.observacionControl2.value);
      obsSize = 2;
    } else {
      // @ts-ignore
      this.observation.push('');
    }
    if (this.observacionControl3.value || this.observacionControl3.dirty) {
      // @ts-ignore
      this.observation.push(this.observacionControl3.value);
      obsSize = 3;
    } else {
      // @ts-ignore
      this.observation.push('');
    }
    for (let i = 0; i < obsSize; i++) {
      // @ts-ignore
      var obs = new Observacion();
      obs.origen = this.origen;
      obs.ptoEmision = this.ptoEmisionControl.value;
      if (i === 0) {
        // @ts-ignore
        obs.observacion = this.observacionControl1.value;
        obs.nroItemObs = 1;
        //todo: add fecProrrogas Date
        // obs.fecProrrogas = new Date();
      }
      if (i === 1) {
        // @ts-ignore
        obs.observacion = this.observacionControl2.value;
        obs.nroItemObs = 2;
        //todo: add fecProrrogas Date
        // obs.fecProrrogas = new Date();
      }
      if (i === 2) {
        // @ts-ignore
        obs.observacion = this.observacionControl3.value;
        obs.nroItemObs = 3;
        //todo: add fecProrrogas Date
        // obs.fecProrrogas = new Date();
      }
      obs.fecCreacion = new Date();
      obs.usrCreacion = this.user;
      obs.fecModif = new Date();
      obs.usrModif = '';
      this.remitos.observacions.push(obs);
    }
    return;
  }

  saveProrrogas() {
    this.remitos.prorrogases = [];
    for (let i = 0; i < this.prorrogas.controls.length; i++) {
      if (this.prorrogas.controls[i].dirty) {
        var prorrogas = new Prorrogas();
        prorrogas.id = this.prorrogas.controls[i].value.id;
        prorrogas.nroItemObs = this.prorrogas.controls[i].value.nroItemObs;
        prorrogas.origen = this.origen;
        prorrogas.ptoEmision = this.ptoEmisionControl.value;
        prorrogas.observacion = this.prorrogas.controls[i].value.observacion;
        prorrogas.fecCreacion = new Date();
        prorrogas.usrCreacion = this.user;
        prorrogas.fecModif = new Date();
        prorrogas.usrModif = this.user;
        prorrogas.fecProrrogas = this.prorrogas.controls[i].value.fecProrrogas;
        this.remitos.prorrogases.push(prorrogas);
      }
    }
    return;
  }

  saveRetorno() {
    this.remitos.fecRetorno = this.fechaRetornoControl.value;
    this.remitos.docRetorno = this.docRetornoControl.value;
    return;
  }

  generateRemitosPopup(previousRemito: Boolean) {
    if (!this.isView) {
      this.isSaving = true;
      this.remitoService.addRemito(this.remitos).subscribe({
        next: (response) => {
          this.dialog.open(GenerateRemitosNumberComponent, {
            data: {remitoNum: response, ptoEmision: this.ptoEmisionControl.value, previousRemito},
          }).afterClosed().subscribe(result => {
            this.clearForm();
          })
          this.isSaving = false;
        },
        error: (error) => {
          this.errors.push(error);
          this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), "error")
          this.isSaving = false;
        }
      });
    } else {
      this.generateUpdatedRemitosPopup(this.remitos, previousRemito);
    }
  }

  disabledPrinted() {
    if (this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView || this.remitoType === 'MGO') {
      this.nroTicketControl.disable();
      this.fecGenControl.disable();
      this.fecSalidaControl.disable();
      this.fecARetornarControl.disable();
      this.solicitanteControl.disable();
      this.transporteControl.disable();
      this.motivoControl.disable();
      this.destinatarioControl.disable();
      this.pNetoControl.disable();
      this.pBrutoControl.disable();
      this.taraControl.disable();
      this.cantContControl.disable();
      this.nroRemitoControl.disable();
      if (this.remitoType != 'MGO' || this.remitoStatus != 'Aprobado') {
        this.patenteControl.disable();
        this.observacionControl1.disable();
        this.observacionControl2.disable();
        this.observacionControl3.disable();
      }
      if (this.fechaRetornoControl.value) {
        this.docRetornoControl.disable();
        this.fechaRetornoControl.disable();
        this.saveDisabled = true;
      }

    }
    if (this.remitoStatus === 'Cancelado' || this.canView || (this.remitoType === 'MGO' && this.remitoStatus === 'Impreso')
      || (this.remitoStatus === 'Impreso' && this.fecARetornarControl.value === null)) {
      this.saveDisabled = true;
    }
    if (this.remitoStatus === 'Aprobado' || this.canView) {
      this.saveDisabled = false;
    }

  }

  clearForm() {
    this.formDirective.resetForm();
    this.ptoEmisionControl.setValue(this.allPtoEmision.find(p => p.code == this.selectedOption)?.code ?? this.selectedOption);
    this.nroTicketControl.setValue('');
    this.claseSelected = 'N';
    this.patenteControl.setValue('');
    this.todayDate.setValue(new Date());
    this.fecGenControl.setValue(new Date());
    this.fecSalidaControl.setValue(new Date());
    this.fecARetornarControl.setValue(null);
    this.solicitanteControl.setValue('');
    this.almacenControl.setValue('');
    this.dockControl.setValue('');
    this.transporteControl.setValue('');
    this.patenteControl.setValue('');
    this.motivoControl.setValue('');
    this.destinatarioControl.setValue('');
    this.pNetoControl.setValue(null);
    this.taraControl.setValue(null);
    this.cantContControl.setValue('');
    this.pBrutoControl.setValue(null);
    this.observacionControl1.setValue('');
    this.observacionControl2.setValue('');
    this.observacionControl3.setValue('');
    this.detalle.reset();
    this.detallePayload.reset();
    while (this.detalle.length !== 1) {
      this.detalle.removeAt(0);
      this.detallePayload.removeAt(0);
    }
    this.observation = [];
    this.markControlsPristine(this.createRemitoForm); // after values
  }

  checkDetalle(): boolean {
    if (this.detalle.dirty) {
      return true;
    } else {
      return false;
    }
    return true;
  }


  public static checkInValidList(validList: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return validList.includes(control.value) ? null : {'in-valid-list': true};
    }
  }

  public static checkDockEstado(dockEstado: Boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      return dockEstado ? null : {'dock-inactive': true};
    }
  }

  public markControlsPristine(group: FormGroup | FormArray): void {
    Object.keys(group.controls).forEach((key: string) => {
      // @ts-ignore
      const abstractControl = group.controls[key];
      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.markControlsPristine(abstractControl);
      } else {
        abstractControl.markAsPristine();
      }
    });
  }

  private hideSection(details: any, observacion: any) {
    if (!details || details.length === 0 && (this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView)) {
      this.hideDetails = true;
    }
    if (!observacion || observacion.length === 0 && (this.remitoStatus === 'Impreso' || this.remitoStatus === 'Cancelado' || this.canView)) {
      this.hideObservacion = true;
    }
    if (!this.docRetornoControl.value && this.canView) {
      this.hideRetorno = true;
    }

    if (!this.prorrogas || this.prorrogas.length === 0 && this.canView) {
      this.hideProrrogas = true;
    }
  }

  private generateUpdatedRemitosPopup(remitos: Remito, previousRemito: Boolean) {
    this.remitoService.updateRemito(remitos, this.remitoNumFromRoute).subscribe({
      next: (response) => {
        this.dialog.open(GenerateRemitosNumberComponent, {
          data: {
            remitoNum: this.nroRemitoControl.value,
            ptoEmision: this.ptoEmisionControl.value,
            previousRemito: this.previousRemito
          }
        }).afterClosed().subscribe(result => {
          //location.reload();
          this.router.navigate(["../..", remitos.ptoEmision, remitos.nroRemito], {relativeTo: this.route});
        })

      },
      error: (error) => {
        this.errors.push(error);
        this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), "error")
      }
    });
  }

  getRemitoTypeByPtoEmision(ptoEmision: string): RemitoTypes {
    switch (ptoEmision) {
      case "0036":
      case "0038":
        return RemitoTypes.BALANZA;
      default:
        return RemitoTypes.FREE;
    }
  }

  changeRemitoType(remitoType: RemitoTypes) {
    if (this.remitoType !== remitoType) {
      this.remitoType = remitoType;
      if (remitoType == RemitoTypes.BALANZA) {
        // Balanza does not have Prorrogas, Observacion, and nroRemito is editable
        this.hideDetails = this.hideProrrogas = this.hideObservacion = true;
        this.origen = "BAL";
        this.nroRemitoControl.enable();
        this.fecARetornarControl.disable();
        this.nroRemitoControl.addValidators([Validators.required, Validators.maxLength(8), Validators.minLength(5), Validators.pattern("[0-9]*")]);
        this.nroRemitoControl.reset();
        this.fecGenControl.enable();
      } else {
        // Remitos has Prorrogas, Observacion, and nroRemito is not editable
        this.hideDetails = this.hideProrrogas = this.hideObservacion = false;
        this.origen = "FRE";
        this.nroRemitoControl.disable();
        this.fecARetornarControl.enable();
        this.fecGenControl.disable();
        this.fecGenControl.setValue(new Date());

        // Clear validator and reset NRO Remito field when change back to Remito Free type
        this.nroRemitoControl.clearValidators();
        this.nroRemitoControl.reset();
      }
    }
  }
}
